import { CustomerIntegrationSettings, Selector } from 'types';

export const getIntegrationSettings: Selector<CustomerIntegrationSettings | null> = (state) =>
  state.integrationSettings.integrationSettings;

export const getIntegrationSettingsForm: Selector<
  Partial<CustomerIntegrationSettings> & { retention_period: string }
> = (state) => state.integrationSettings.integrationSettingsForm;

export const getIntegrationSettingsLoading: Selector<boolean> = (state) =>
  state.integrationSettings.loading.includes('');
